import React, { useState } from 'react'

import { Cores } from 'src/componentes/styles/cores'
import styled from 'styled-components'

const LIMITE_CARACTERES = 160

const Container = styled.span<{ tipo: 'erro' | 'alerta' }>`
  display: block;
  font-size: 11px;
  margin-top: 3px;
  color: ${({ tipo }) =>
    tipo === 'erro' ? Cores.PERIGO_ERRO : Cores.ATENCAO_ESCURO};
`

const Texto = styled.span<{ expandido: boolean }>`
  white-space: ${({ expandido }) => (expandido ? 'pre-wrap' : 'normal')};
  word-break: break-word;
`

const BotaoLerMais = styled.button`
  margin-left: 6px;
  padding: 0;
  border: 0;
  background: transparent;
  color: ${Cores.SECUNDARIA_1_ESCURO};
  font-size: 11px;
  font-weight: 600;
  cursor: pointer;

  :hover {
    text-decoration: underline;
  }
`

interface MensagemErroProps {
  mensagem: string
  tipo?: 'erro' | 'alerta'
  /** Prefixo visual (ex.: "└ "). */
  prefixo?: string
}

/** Mensagem de erro/dica truncada com "ler mais"/"ler menos" (stack traces longos). */
export const MensagemErro: React.FC<MensagemErroProps> = ({
  mensagem,
  tipo = 'erro',
  prefixo = '└ '
}) => {
  const [expandido, definirExpandido] = useState(false)
  const ehLonga = mensagem.length > LIMITE_CARACTERES

  const conteudo =
    expandido || !ehLonga
      ? mensagem
      : `${mensagem.slice(0, LIMITE_CARACTERES).trimEnd()}…`

  return (
    <Container tipo={tipo}>
      {prefixo}
      <Texto expandido={expandido}>{conteudo}</Texto>
      {ehLonga && (
        <BotaoLerMais
          type="button"
          onClick={() => definirExpandido(old => !old)}
        >
          {expandido ? 'ler menos' : 'ler mais'}
        </BotaoLerMais>
      )}
    </Container>
  )
}
